import { render, staticRenderFns } from "./CooperateManagement.vue?vue&type=template&id=061447b0&scoped=true"
import script from "./CooperateManagement.vue?vue&type=script&lang=js"
export * from "./CooperateManagement.vue?vue&type=script&lang=js"
import style0 from "./CooperateManagement.vue?vue&type=style&index=0&id=061447b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061447b0",
  null
  
)

export default component.exports